var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 2V42L12.3364 32.4478V13.0919L2 2Z",
    fill: "#FD7919",
    fillOpacity: 0.9,
    stroke: "url(#paint0_linear_9520_4710)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.998 2.03149L2.00781 2.03149L12.3854 12.9143L32.418 12.3379L41.998 2.03149Z",
    fill: "#EF6C00",
    stroke: "url(#paint1_linear_9520_4710)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9520_4710",
    x1: 12.3363,
    y1: 22.7698,
    x2: 2,
    y2: 22.7698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA6434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA6434",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9520_4710",
    x1: 22.712,
    y1: 12.3378,
    x2: 22.712,
    y2: 2.03148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA6434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA6434",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape);
export default __webpack_public_path__ + "static/media/Shape.d04131e0184ee5ef68986d77eacbc3e7.svg";
export { ForwardRef as ReactComponent };